import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LoadableEntitiesUtils } from '@spaces-ui/loadable-entities';
import { MdwAside } from '@spaces-ui/meadow/components/aside';
import { MdwButton } from '@spaces-ui/meadow/components/button';
import { MdwNotificationsService } from '@spaces-ui/meadow/components/notifications';
import { Sidebar_Duotone } from '@spaces-ui/meadow/icons/svgs';

import { AppSecondarySidebar, AppTopSidebar } from './components';

@Component({
  imports: [RouterModule, AppSecondarySidebar, AppTopSidebar, MdwAside, MdwButton],
  selector: 'app-root',
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss',
})
export class App {
  private notificationService = inject(MdwNotificationsService);

  public icons = { Sidebar_Duotone };
  public sidebarIsCollapsed = false;
  public sidebarIsFloating = false;

  public constructor() {
    LoadableEntitiesUtils.registerNotificationService(this.notificationService);
  }

  toggleSidebar() {
    this.sidebarIsCollapsed = !this.sidebarIsCollapsed;
  }
}
